<div class="sig-wrap">
  <div class="sig-actions">
    <button type="button" (click)="clear()">X Borrar</button>
  </div>
  <canvas
    #sigCanvas
    class="sig-canvas"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (pointerleave)="onPointerUp($event)"
  ></canvas>
</div>
